// ЛОГИСТИЧЕН МОДУЛ: СПИДИ V3 ФИНАЛЕН ФИКС ЗА ГРАД И АДРЕС (ЧИСТ JS)
document.addEventListener("DOMContentLoaded", function() {
  const officeInput = document.getElementById("magoo_selected_office_text");
  const cityInput = document.getElementById("magoo_city");
  const zipInput = document.getElementById("magoo_zip_code");
  const submitBtn = document.getElementById("magooSubmitBtn");

  window.addEventListener("message", function(event) {
    if (!event.origin.includes("speedy.bg")) return;

    console.log("Прехванат софтуерен сигнал от Спиди V3:", event.data);

    if (event.data) {
      const office = event.data.office ? event.data.office : event.data;
      
      if (!office.name && !office.id) return;

      const name = office.name || "";
      
      // СТРАТЕГИЯ ЗА СИГУРНОСТ: Извличаме града от абсолютно всички възможни полета
      let city = office.siteName || 
                 office.cityName || 
                 (office.address && office.address.siteName) || 
                 (office.address && office.address.cityName) || 
                 "София"; // Дефолтна стойност при краен случай, за да не блокира тунела
      
      // Почистваме град от евентуални "гр. " префикси за Shopify съвместимост
      city = city.replace(/^гр\.\s+/i, "").trim();

      // Проверяваме всички възможни низове за адрес
      let fullAddress = "";
      if (office.address) {
        if (typeof office.address === 'string') {
          fullAddress = office.address;
        } else {
          fullAddress = office.address.fullAddressString || 
                        office.address.fullAddress || 
                        office.address.addressString || 
                        office.fullAddress || 
                        "";
          
          if (!fullAddress) {
            const cityType = office.address.siteType || "гр.";
            const cityName = city || "";
            const quarter = office.address.quarter || office.address.frat || "";
            const street = office.address.street || office.address.streetName || "";
            const number = office.address.number || office.address.streetNo || "";
            const block = office.address.block || "";
            
            const qText = quarter ? (quarter.toLowerCase().includes("кв.") ? quarter : "кв. " + quarter) : "";
            const sText = street ? (street.toLowerCase().includes("ул.") ? street : "ул. " + street) : "";
            const nText = number ? "No " + number : "";
            const bText = block ? "бл. " + block : "";
            
            fullAddress = `${cityType} ${cityName} ${qText} ${sText} ${nText} ${bText}`.replace(/\s+/g, ' ').trim();
          }
        }
      }

      // Търсим пощенския код
      const postCode = office.postCode || 
                       (office.address && office.address.postCode) || 
                       "1000";

      if (name) {
        if (name.includes("APS") || name.includes("Автомат") || name.includes("Automat")) {
          alert("Доставката до Спиди автомати не е възможна. Моля, изберете физически офис от списъка на картата!");
          if (officeInput) officeInput.value = "";
          if (submitBtn) submitBtn.disabled = true;
          return;
        }

        // ЗАКОУВАМЕ АБСОЛЮТНО ВСИЧКИ ДАННИ ЕДНОВРЕМЕННО
        if (officeInput) {
          officeInput.value = "Спиди: " + name + (fullAddress ? " (" + fullAddress + ")" : "");
        }
        if (cityInput) {
          cityInput.value = city;
        }
        if (zipInput) {
          zipInput.value = postCode;
        }
        
        // ВЕЧЕ СВЕТВА: Отключваме бутона за финална поръчка на секундата!
        if (submitBtn) {
          submitBtn.disabled = false;
        }
        
        console.log("Успешно заковани: Град (" + city + ") и Пълен адрес!");
      }
    }
  }, false);
});